import globals from "./globals";
import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
// import { gsapTrigger as WyPt, getOffset } from "Utilities";

const component = (function () {
    /**
     * Initialize Hero instances
     */
    $(window).on("preloaderHidden", function () {
        if ($("#outro").length) {
            if (globals.debug) console.log("component-outro initialized");

            gsap.registerPlugin(ScrollTrigger);
            ScrollTrigger.create({
                trigger: $("#outro")[0],
                start: "top top",
                endTrigger: "html",
                end: "bottom top",
                onToggle: (self) => {
                    if (self.isActive) {
                        $(self.trigger).find(".zoom-outro").addClass("on");
                    } else {
                        $(self.trigger).find(".zoom-outro").removeClass("on");
                    }
                },
                // markers: true,
            });
        }
    });
})();

export default component;
